import { useEffect, useState } from 'react'

/** Whether a moment has passed, re-rendering when it does: also right away for one already past when the question is first shown. */
export function useExpired(at: string | null): boolean {
  const deadline = at ? Date.parse(at) : null
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (deadline === null) return
    const left = deadline - Date.now()
    if (left <= 0) {
      setNow(Date.now())
      return
    }
    const timer = setTimeout(() => setNow(Date.now()), left)
    return () => clearTimeout(timer)
  }, [deadline])
  return deadline !== null && now >= deadline
}
